/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateVolumeVo
 */
export interface UpdateVolumeVo {
    /**
     * 商品重量 kg
     * @type {number}
     * @memberof UpdateVolumeVo
     */
    weight?: number;
    /**
     * 商品长度
     * @type {number}
     * @memberof UpdateVolumeVo
     */
    length?: number;
    /**
     * 商品宽度
     * @type {number}
     * @memberof UpdateVolumeVo
     */
    width?: number;
    /**
     * 商品高度
     * @type {number}
     * @memberof UpdateVolumeVo
     */
    height?: number;
    /**
     * 商品CBM
     * @type {number}
     * @memberof UpdateVolumeVo
     */
    cbm?: number;
}

/**
 * Check if a given object implements the UpdateVolumeVo interface.
 */
export function instanceOfUpdateVolumeVo(value: object): value is UpdateVolumeVo {
    return true;
}

export function UpdateVolumeVoFromJSON(json: any): UpdateVolumeVo {
    return UpdateVolumeVoFromJSONTyped(json, false);
}

export function UpdateVolumeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVolumeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
    };
}

export function UpdateVolumeVoToJSON(json: any): UpdateVolumeVo {
    return UpdateVolumeVoToJSONTyped(json, false);
}

export function UpdateVolumeVoToJSONTyped(value?: UpdateVolumeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
    };
}

